module.exports = __webpack_public_path__ + "static/comfort-1-52d70fb83e5bb67454e735a4a41e3387.png";